<template>
  <div class="spec">
    <div class="section dimensisions">
      <div class="section-nav">
        <i class="el-icon-arrow-right"></i>
        Dimensions
      </div>
      <div class="section-content">
        <el-image
          class="spec-img"
          lazy
          src="//cdn.weappdev.cn/wp-content/uploads/sites/77/2022/06/dim.png"
        >
        </el-image>
      </div>
    </div>
    <!--  -->

    <div class="section materials">
      <div class="section-nav">
        <i class="el-icon-arrow-right"></i>
        Materials
      </div>

      <div class="section-content">
        <div class="rows">
          <div class="header">
            <div class="nav">Woods</div>
            <div class="more">
              <a href=""> View More <i class="el-icon-arrow-right"></i></a>
            </div>
          </div>
          <el-row class="items" :gutter="10">
            <el-col class="item" v-for="(i, idx) in 4" :key="'x' + idx">
              <div class="item-thumb">
                <el-image
                  lazy
                  src="//cdn.weappdev.cn/wp-content/uploads/sites/77/2022/06/EZ-W01.png"
                >
                </el-image>
              </div>
              <div class="item-title">EZ-W01</div>
            </el-col>
          </el-row>
        </div>
        <!--  -->

        <div class="rows">
          <div class="header">
            <div class="nav">Fabric</div>
            <div class="more">
              <a href=""> View More <i class="el-icon-arrow-right"></i></a>
            </div>
          </div>
          <el-row class="items" :gutter="10">
            <el-col class="item" v-for="(i, idx) in 4" :key="'x' + idx">
              <div class="item-thumb">
                <el-image
                  lazy
                  src="//cdn.weappdev.cn/wp-content/uploads/sites/77/2022/06/EZ-W01.png"
                >
                </el-image>
              </div>
              <div class="item-title">EZ-W01</div>
            </el-col>
          </el-row>
        </div>
        <!--  -->

        <div class="rows">
          <div class="header">
            <div class="nav">Metal</div>
            <div class="more">
              <a href=""> View More <i class="el-icon-arrow-right"></i></a>
            </div>
          </div>
          <el-row class="items" :gutter="10">
            <el-col class="item" v-for="(i, idx) in 7" :key="'x' + idx">
              <div class="item-thumb">
                <el-image
                  lazy
                  src="//cdn.weappdev.cn/wp-content/uploads/sites/77/2022/06/EZ-W01.png"
                >
                </el-image>
              </div>
              <div class="item-title">EZ-W01</div>
            </el-col>
          </el-row>
        </div>

        <!--  -->
      </div>
    </div>

    <!--  -->

    <div class="section materials">
      <div class="section-nav">
        <i class="el-icon-arrow-right"></i>
        Power and Data
      </div>
      <div class="section-content">
        <el-image
          class="material-image"
          lazy
          src="//cdn.weappdev.cn/wp-content/uploads/sites/77/2022/06/image16.png"
        >
        </el-image>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Spec",
};
</script>
<style lang="scss" scoped>
.materials {
  margin-top: 200px;
}

.section {
  &-nav {
    font-weight: 700;
    font-size: 50px;
    line-height: 59px;
    color: #3f3f3f;
    display: flex;
    align-items: center;

    ::v-deep .el-icon-arrow-right {
      font-size: 20px;
      margin-right: 10px;
      font-weight: bold;
    }
  }

  &-content {
    .material-image {
      margin-top: 88px;
      margin-bottom: 88px;
    }

    .rows {
      margin-left: 120px;
      margin-top: 92px;

      margin-right: 70px;

      .header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 23px;

        .nav {
          font-family: "Roboto";
          font-style: normal;
          font-weight: 700;
          font-size: 25px;
          color: #3f3f3f;
        }

        .more {
          a {
            text-decoration: none;
            font-family: "Roboto";
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            line-height: 21px;
            color: #3f3f3f;

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }

      .items {
        display: flex;
        justify-content: space-between;

        .item {
          text-align: center;

          &-title {
            margin-top: 25px;
          }

          &-thumb {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
